import {
  SpecialConditionData,
  CustomConditionModel,
  SpecialConditionDataConditionType,
} from '@urbanx/agx.campaigns.client'

export const getModelFromCustomCondition = (
  customCondition: SpecialConditionData
): CustomConditionModel | undefined => {
  if (
    customCondition.conditionType !== SpecialConditionDataConditionType.Custom
  )
    return undefined

  const clause = customCondition.clauses?.[0]
  const dataPoint = clause?.dataPoints?.[0]
  const model = dataPoint?.model?.custom

  return model
}
